import { VatStatus } from './enums';

/** ISO-2 country code for Spain (the selling company's home country). */
export const SPAIN_COUNTRY_CODE = 'ES';

/**
 * Canary Islands: ISO 3166-1 exceptionally reserved code `IC`. Spanish territory
 * (NIF/CIF rules, national client) but outside the EU VAT area — Holded applies the
 * IGIC regime there, we only carry the flag.
 */
export const CANARY_ISLANDS_CODE = 'IC';

/** True for mainland Spain and the Canary Islands (Spanish tax numbers apply). */
export function isSpanishTerritory(countryCode: string | null | undefined): boolean {
  const cc = (countryCode ?? '').trim().toUpperCase();
  return cc === SPAIN_COUNTRY_CODE || cc === CANARY_ISLANDS_CODE;
}

/**
 * Intra-EU reverse charge: a sale to a non-Spanish client whose VAT number is filled
 * and VIES-VALID is invoiced at 0% VAT (the customer self-accounts). In every other
 * case — Spanish client, or no / invalid VAT — the standard 21% applies.
 *
 * `countryCode` is the client's billing-country ISO-2 code; `vatStatus` is the stored
 * VIES status. Unknown country → not reverse charge (charge VAT).
 */
export function isReverseCharge(
  countryCode: string | null | undefined,
  vatStatus: VatStatus | null | undefined,
): boolean {
  const cc = (countryCode ?? '').trim().toUpperCase();
  return cc !== '' && !isSpanishTerritory(cc) && vatStatus === VatStatus.VALID;
}
